export default function AboutSection() {
  return (
    <section id="quienes-somos" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-800 rounded-full mx-auto mb-6">
              <i className="ri-building-line text-5xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Quiénes Somos
            </h2>
            <div className="w-24 h-1 bg-gray-800 mx-auto mb-8"></div>
          </div>

          <div className="bg-gray-50 p-10 rounded-2xl mb-12 shadow-lg">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Congarantías es una empresa con más de una década de trayectoria, respaldada por la experiencia de sus aliados en el sector financiero. Nos especializamos en la gestión, administración y compra de cartera, apoyados en modelos operativos eficientes y soluciones tecnológicas propias.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Con más de 50.000 clientes y una cartera cercana a $1 billón, trabajamos para fortalecer la situación financiera de nuestros usuarios mediante servicios orientados a la transparencia, eficacia y acompañamiento integral.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gray-50 p-8 rounded-xl text-center border-2 border-gray-300 shadow-lg hover:border-gray-800 transition-colors">
              <div className="flex items-center justify-center w-20 h-20 bg-gray-800 rounded-full mx-auto mb-4">
                <i className="ri-time-line text-4xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-black mb-2">+10</div>
              <div className="text-gray-700 font-medium">Años de Experiencia</div>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl text-center border-2 border-gray-300 shadow-lg hover:border-gray-800 transition-colors">
              <div className="flex items-center justify-center w-20 h-20 bg-gray-800 rounded-full mx-auto mb-4">
                <i className="ri-group-line text-4xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-black mb-2">+50,000</div>
              <div className="text-gray-700 font-medium">Clientes Atendidos</div>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl text-center border-2 border-gray-300 shadow-lg hover:border-gray-800 transition-colors">
              <div className="flex items-center justify-center w-20 h-20 bg-gray-800 rounded-full mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-4xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-black mb-2">$1B</div>
              <div className="text-gray-700 font-medium">Cartera Administrada</div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-xl border-l-4 border-gray-800">
              <div className="flex items-center gap-4 mb-4">
                <div className="flex items-center justify-center w-16 h-16 bg-gray-800 rounded-full flex-shrink-0">
                  <i className="ri-target-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-black">Misión</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Contribuir al bienestar financiero de nuestros clientes mediante la administración y gestión eficiente de cartera, ofreciendo soluciones responsables, procesos transparentes y un servicio de alta calidad apoyado en tecnología y modelos operativos confiables.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-xl border-l-4 border-gray-800">
              <div className="flex items-center gap-4 mb-4">
                <div className="flex items-center justify-center w-16 h-16 bg-gray-800 rounded-full flex-shrink-0">
                  <i className="ri-eye-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-black">Visión</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Ser una empresa líder y referente nacional en la gestión y administración de cartera, reconocida por su solidez, innovación tecnológica, excelencia operativa y compromiso con la recuperación financiera de nuestros clientes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
